import VueApollo from '@vue/apollo-option';
import { apolloClient } from '@/modules/common/services/graphql/apollo-client';

// docs at https://apollo.vuejs.org/api/apollo-provider.html#constructor
export const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});
